module.exports = __webpack_public_path__ + "assets/img/onlineSupport-banner.d504707b.png";